import { render } from "./StoreTicketPrice.vue?vue&type=template&id=4384234a&scoped=true"
import script from "./StoreTicketPrice.vue?vue&type=script&lang=js"
export * from "./StoreTicketPrice.vue?vue&type=script&lang=js"

import "./StoreTicketPrice.vue?vue&type=style&index=0&id=4384234a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4384234a"

export default script